import React from 'react';
import { ClientRegister } from 'components';

export default function ClientRegisterComponent() {
    return <ClientRegister />;
}
